module.exports = __webpack_public_path__ + "img/koscielecki.ecd8cc5c.jpg";